// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__t93_2","infoBtn":"quickbooks_infoBtn__1z63I","formBox":"quickbooks_formBox__2livq","formFooter":"quickbooks_formFooter__2ZC7W"};